import * as React from 'react';

export interface SoleProprietorshipIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * SoleProprietorshipIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Sole Proprietorship / DBA. Brushed brass nameplate engraved with 'DBA'.
 */
const SoleProprietorshipIcon: React.FunctionComponent<SoleProprietorshipIconProps> = ({
  className,
  size = 40,
  title = 'Sole Proprietorship / DBA',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="6" y="14" width="36" height="22" fill="#1f4f84"/>
      <rect x="4" y="12" width="40" height="22" rx="1" fill="#d4a958"/>
      <rect x="4" y="12" width="40" height="11" rx="1" fill="#e8c878" opacity="0.7"/>
      <rect x="7" y="15" width="34" height="16" fill="none" stroke="#8a6a2c" strokeWidth="0.6"/>
      <text x="24" y="28" textAnchor="middle" fontFamily="serif" fontSize="13" fontWeight="900" fill="#5a4416" letterSpacing="1.2">DBA</text>
      <circle cx="8" cy="16" r="0.8" fill="#8a6a2c"/>
      <circle cx="40" cy="16" r="0.8" fill="#8a6a2c"/>
      <circle cx="8" cy="30" r="0.8" fill="#8a6a2c"/>
      <circle cx="40" cy="30" r="0.8" fill="#8a6a2c"/>
  </svg>
);

export default SoleProprietorshipIcon;
